/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { UpdatePromisedAvailTimeRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { UpdatePromisedAvailTimeResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * UpdatePromisedAvailTimeApi - axios parameter creator
 * @export
 */
export const UpdatePromisedAvailTimeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update PromisedAvailTime
         * @summary Update PromisedAvailTime
         * @param {string} storeId The store identifier.
         * @param {UpdatePromisedAvailTimeRequest} updatePromisedAvailTimeRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromisedAvailTime: async (storeId: string, updatePromisedAvailTimeRequest: UpdatePromisedAvailTimeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('updatePromisedAvailTime', 'storeId', storeId)
            // verify required parameter 'updatePromisedAvailTimeRequest' is not null or undefined
            assertParamExists('updatePromisedAvailTime', 'updatePromisedAvailTimeRequest', updatePromisedAvailTimeRequest)
            const localVarPath = `/store/{storeId}/shipping/updatePromisedAvailTime`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePromisedAvailTimeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdatePromisedAvailTimeApi - functional programming interface
 * @export
 */
export const UpdatePromisedAvailTimeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdatePromisedAvailTimeApiAxiosParamCreator(configuration)
    return {
        /**
         * Update PromisedAvailTime
         * @summary Update PromisedAvailTime
         * @param {string} storeId The store identifier.
         * @param {UpdatePromisedAvailTimeRequest} updatePromisedAvailTimeRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromisedAvailTime(storeId: string, updatePromisedAvailTimeRequest: UpdatePromisedAvailTimeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePromisedAvailTimeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromisedAvailTime(storeId, updatePromisedAvailTimeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdatePromisedAvailTimeApi - factory interface
 * @export
 */
export const UpdatePromisedAvailTimeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdatePromisedAvailTimeApiFp(configuration)
    return {
        /**
         * Update PromisedAvailTime
         * @summary Update PromisedAvailTime
         * @param {string} storeId The store identifier.
         * @param {UpdatePromisedAvailTimeRequest} updatePromisedAvailTimeRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromisedAvailTime(storeId: string, updatePromisedAvailTimeRequest: UpdatePromisedAvailTimeRequest, options?: any): AxiosPromise<UpdatePromisedAvailTimeResponse> {
            return localVarFp.updatePromisedAvailTime(storeId, updatePromisedAvailTimeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdatePromisedAvailTimeApi - object-oriented interface
 * @export
 * @class UpdatePromisedAvailTimeApi
 * @extends {BaseAPI}
 */
export class UpdatePromisedAvailTimeApi extends BaseAPI {
    /**
     * Update PromisedAvailTime
     * @summary Update PromisedAvailTime
     * @param {string} storeId The store identifier.
     * @param {UpdatePromisedAvailTimeRequest} updatePromisedAvailTimeRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdatePromisedAvailTimeApi
     */
    public updatePromisedAvailTime(storeId: string, updatePromisedAvailTimeRequest: UpdatePromisedAvailTimeRequest, options?: any) {
        return UpdatePromisedAvailTimeApiFp(this.configuration).updatePromisedAvailTime(storeId, updatePromisedAvailTimeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
